const primary = {
    base: { value: '#9D00FF', tone: 44.784445076762466 },
    values: {
        '0': '#000000',
        '10': '#2D004F',
        '20': '#4B007E',
        '30': '#6B00B0',
        '40': '#8C00E5',
        '50': '#A739FF',
        '60': '#BA6BFF',
        '70': '#CD92FF',
        '80': '#DFB7FF',
        '90': '#F1DAFF',
        '95': '#FAECFF',
        '98': '#FFF7FD',
        '100': '#FFFFFF'
    }
}

const secondary = {
    base: { value: '#EC36C5', tone: 56.58735496283168 },
    values: {
        '0': '#000000',
        '10': '#3B002F',
        '20': '#5F004E',
        '30': '#86006F',
        '40': '#B00092',
        '50': '#D61CB3',
        '60': '#F741CF',
        '70': '#FF7CD9',
        '80': '#FFADE2',
        '90': '#FFD8ED',
        '95': '#FFECF4',
        '98': '#FFF8F9',
        '100': '#FFFFFF'
    }
}

const accent = {
    base: { value: '#FFBF00', tone: 81.02792148118404 },
    values: {
        '0': '#000000',
        '10': '#261A00',
        '20': '#402D00',
        '30': '#5C4300',
        '40': '#795900',
        '50': '#987100',
        '60': '#B88900',
        '70': '#D9A200',
        '80': '#FBBC00',
        '90': '#FFDFA0',
        '95': '#FFEFD5',
        '98': '#FFF8F2',
        '100': '#FFFFFF'
    }
}

const success = {
    base: { value: '#00BA8F', tone: 67.35272228709262 },
    values: {
        '0': '#000000',
        '10': '#002117',
        '20': '#003829',
        '30': '#00513D',
        '40': '#006C51',
        '50': '#008767',
        '60': '#00A47E',
        '70': '#1CC196',
        '80': '#4ADEB0',
        '90': '#6BFBCB',
        '95': '#BBFFE3',
        '98': '#E7FFF2',
        '100': '#FFFFFF'
    }
}

const warning = {
    base: { value: '#FF950B', tone: 71.40475275105044 },
    values: {
        '0': '#000000',
        '10': '#2D1600',
        '20': '#4B2800',
        '30': '#6B3B00',
        '40': '#8D4F00',
        '50': '#B06400',
        '60': '#D57A00',
        '70': '#FA9102',
        '80': '#FFB875',
        '90': '#FFDCC0',
        '95': '#FFEEE1',
        '98': '#FFF8F5',
        '100': '#FFFFFF'
    }
}

const error = {
    base: { value: '#FF0040', tone: 53.632384899121774 },
    values: {
        '0': '#000000',
        '10': '#410009',
        '20': '#680014',
        '30': '#920020',
        '40': '#BF002D',
        '50': '#EE003B',
        '60': '#FF525F',
        '70': '#FF888A',
        '80': '#FFB3B3',
        '90': '#FFDAD9',
        '95': '#FFEDEC',
        '98': '#FFF8F7',
        '100': '#FFFFFF'
    }
}

const neutral = {
    values: {
        '0': '#000000',
        '10': '#161616', // title -> True tone: 7.3,
        '20': '#303030',
        '30': '#505050', // body -> True tone: 34,
        '40': '#5E5E5E',
        '50': '#757575', // label -> True tone: 49,
        '60': '#9D9D9D', // placeholder -> True tone: 64.6,
        '70': '#ABABAB',
        '80': '#C6C6C6',
        '90': '#DDDDDD', // line -> True tone: 88,
        '95': '#F0F0F0', // inputBackground,
        '98': '#F9F9F9', // background,
        '100': '#FFFFFF'
    }
}

const palette = {
    primary,
    secondary,
    accent,
    success,
    warning,
    error,
    neutral,
}


// export const getColor = (isDark) => (colorName, option = {}) => {
//     const opts = { reverse: false, dark: false, on: undefined, isText: true, ...option }
//     if (opts.dark)
//         return festoColors.darker[colorName]

//     if (!isDark && !opts.isText) {
//         return getVivid(festoColors.onLight[colorName], festoColors.onDark[colorName])
//     }

//     if (opts.on)
//         return colorIsDark(opts.on) === opts.reverse ? festoColors.onLight[colorName] : festoColors.onDark[colorName];

//     return isDark === opts.reverse ? festoColors.onLight[colorName] : festoColors.onDark[colorName];

// }

// Adapt to legacy values
const LEGACY_NEUTRAL_NAMES = {
    background: 98,
    inputBackground: 95,
    line: 90,
    placeholder: 60,
    label: 50,
    body: 30,
    title: 10
}

const DT_AAA = 50;
const DT_AA = 40;

const clamp = (v, min, max) => Math.min(Math.max(v, min), max);

const getContrastedColor = (colorName, backgroundTone, delta = DT_AA) => {
    let color = palette[colorName];

    // XXX: Check this
    if (!color) color = palette.primary;

    if (Math.abs(backgroundTone - color.base.tone) >= delta) return color.base.value;

    let minTone = clamp(backgroundTone - delta, 0, 100);
    let maxTone = clamp(backgroundTone + delta, 0, 100);
    let possibleValues = [
        Math.floor(minTone / 10) * 10,
        Math.ceil(minTone / 10) * 10,
        Math.floor(maxTone / 10) * 10,
        Math.ceil(maxTone / 10) * 10,
    ].filter(tone => Math.abs(backgroundTone - tone) >= delta).sort((a, b) => b - a);

    return possibleValues.length >= 0 ? color.values[possibleValues[0]] : color.base.value;
}

const _findBackgroundTone = (hexColor) => {
    for (const colorName in palette) {
        let color = palette[colorName]?.base;
        if (!color) {
            break;
        }
        if (color.value === hexColor) {
            return [color.tone, colorName];
        }
    }
    return [LEGACY_NEUTRAL_NAMES.background, 'neutral'];
}

export const getColor = (colorName, option = {}) => {
    const opts = { on: null, isText: true, ...option };

    if (colorName in LEGACY_NEUTRAL_NAMES && !opts.on) return palette.neutral.values[LEGACY_NEUTRAL_NAMES[colorName]];
    let backgroundTone = LEGACY_NEUTRAL_NAMES['background'], backgroundName = 'neutral';
    if (opts.on) {
        [backgroundTone, backgroundName] = _findBackgroundTone(opts.on);
    }
    if (!opts.isText) {
        // Returns the base color
        return palette[colorName].base.value;
    } else {
        let delta = colorName in LEGACY_NEUTRAL_NAMES ? DT_AAA : DT_AA;
        if (colorName === 'title') {
            // Returns always 10 or 100
            if (backgroundTone <= 55) return palette.neutral.values['100'];
            return palette.neutral.values['10']
        } else if (colorName in LEGACY_NEUTRAL_NAMES) {
            colorName = backgroundName;
        }
        return getContrastedColor(colorName, backgroundTone, delta);
    }
}

export const setPalette = (newPalette) => {
    for (const colorName in newPalette) {
        if (colorName in palette) {
            palette[colorName] = newPalette[colorName];
        }
    }
}
